import { Form, Input } from 'antd';
import React from 'react'

function AlertsFilter({ handleClose }) {
    return (
        <>
            <Form layout='vertical'>
                <div className='grid grid-cols-2 gap-2'>
                    <div>
                        <Form.Item label="Date & Time" name="code">
                            <Input placeholder="Enter" />
                        </Form.Item>
                    </div>
                    <div>
                        <Form.Item label="Subject" name="name">
                            <Input placeholder="Enter" />
                        </Form.Item>
                    </div>
                    <div>
                        <Form.Item label="Content" name="brand">
                            <Input placeholder="Enter" />
                        </Form.Item>
                    </div>
                </div>
            </Form>
            <div>
                <div className="flex items-center w-full justify-end my-5">
                    <button onClick={handleClose} className="border-brand-primaryColor border rounded text-brand-primaryColor text-sm px-6 py-1.5">
                        Cancel
                    </button>
                    <button className="bg-brand-primaryColor border-brand-secondaryColor border rounded px-5 py-1.5 text-white text-sm ml-3">
                        Submit
                    </button>
                </div>
            </div>
        </>
    )
}

export default AlertsFilter;